import type { LayoutWorkerConfig } from './layoutWorkerConfig';

// Browsers only start workers from same-origin URLs, so the worker URL is built
// against the page origin even when chunks load from the CDN (see publicPath.ts).
const constructSameOriginWorker = (publicPath: string): Worker => {
  __webpack_public_path__ = new URL(publicPath, window.location.href).pathname;
  try {
    return new Worker(new URL('./runLayout.worker.ts', import.meta.url), {
      type: 'classic',
    });
  } finally {
    __webpack_public_path__ = publicPath;
  }
};

export const createWorker = (): Worker => {
  const publicPath = __webpack_public_path__;
  const worker = constructSameOriginWorker(publicPath);
  const config: LayoutWorkerConfig = {
    publicPath: new URL(publicPath, window.location.href).href,
  };
  worker.postMessage(config);
  return worker;
};
